import type { AxiosRequestConfig } from "axios";
import { ComplianceTrend, TrendMode } from "entities/assets";

import { Meta } from "entities/common";
import {
  CreatePortfolioRequest,
  PortfolioComplianceScore,
  PortfolioIAQDashboard,
  PortfolioItem,
  UpdatePortfolioRequest,
} from "entities/portfolios";
import { DELETE, GET, PATCH, POST } from "utils/http";

const baseUrl = "/api/portfolios";

export const getList = (query = "") => GET<{ items: PortfolioItem[] } & Meta>(`${baseUrl}${query}`);

export const getCurrent = (id: number | string) => GET<PortfolioItem>(`${baseUrl}/${id}`);

export const create = (body: CreatePortfolioRequest) => POST<CreatePortfolioRequest, PortfolioItem>(`${baseUrl}`, body);

export const update = (id: number | string, body: UpdatePortfolioRequest, config?: AxiosRequestConfig) =>
  PATCH<UpdatePortfolioRequest, PortfolioItem>(`${baseUrl}/${id}`, body, config);

export const remove = (id: number | string) => DELETE(`${baseUrl}/${id}`);

export const getComplianceScore = (id: number | string) =>
  GET<PortfolioComplianceScore>(`${baseUrl}/${id}/compliance-score`);

export const getIAQDashboard = ({ id, query = "" }: { id: number | string; query?: string }) =>
  GET<PortfolioIAQDashboard>(`${baseUrl}/${id}/iaq-dashboard${query}`);

export const getComplianceScoreTrend = (id: number | string, mode: TrendMode, date?: string) => {
  const params = new URLSearchParams({ mode });
  if (date) params.set("date", date);
  return GET<ComplianceTrend>(`${baseUrl}/${id}/compliance-trend?${params.toString()}`);
};

export const getIncidentTrend = (id: number | string, mode: TrendMode, date?: string) => {
  const params = new URLSearchParams({ mode });
  if (date) params.set("date", date);
  return GET<ComplianceTrend>(`${baseUrl}/${id}/incident-trend?${params.toString()}`);
};
